<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Contas Bancárias' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>
  <br />
  <ion-accordion-group>
    <ion-accordion *ngFor="let conta of contas; let i = index;">
      <ion-item slot="header" lines="none" class="item-header">
        <ion-thumbnail slot="start">
          <img class="image-heading-contas" [src]="conta.logotipo" />
        </ion-thumbnail>

        <ion-label>
          <h2 class="titulo">{{conta.titular}}</h2>
          <p class="header-bank">{{conta.especificacao}}</p>
        </ion-label>
      </ion-item>

      <ion-item slot="content" lines="none">
        <ion-grid>
          <ion-row class="row-edit">
            <ion-col size="11" class="bold-1" (click)="copiar(conta.agencia)">
              {{'Agência: ' | translate}}
              <p class="bank">{{conta.agencia}}</p>
            </ion-col>
            <ion-col size="1" (click)="copiar(conta.agencia)">
              <i class="fa-thin fa-copy"></i>
            </ion-col>
          </ion-row>

          <ion-row class="row-edit">
            <ion-col size="11" class="bold-1" (click)="copiar(conta.numero)">
              {{'Conta: ' | translate}}
              <p class="bank">{{conta.numero}}</p>
            </ion-col>
            <ion-col size="1" (click)="copiar(conta.numero)">
              <i class="fa-thin fa-copy"></i>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="conta.operacao" class="row-edit">
            <ion-col size="12" class="bold-1">
              {{'Operação' | translate}}
              <p class="bank" text-uppercase>{{conta.operacao}}</p>
            </ion-col>
          </ion-row>

          <ion-row class="row-edit">
            <ion-col size="11" class="bold-1" (click)="copiar(conta.cpf_cnpj)">
              {{'CNPJ: ' | translate}}
              <p class="bank">{{conta.cpf_cnpj}}</p>
            </ion-col>
            <ion-col size="1" (click)="copiar(conta.cpf_cnpj)">
              <i class="fa-thin fa-copy"></i>
            </ion-col>
          </ion-row>

          <ion-row class="row-edit">
            <ion-col size="12" class="bold-1">
              {{'Tipo: ' | translate}}
              <p class="bank" style="text-transform: capitalize;">{{conta.tipoConta | translate}}</p>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="conta.pix" class="ion-align-items-center">
            <ion-col size="11" class="bold-1" (click)="copiar(conta.pix)">
              {{'Pix: ' | translate}}

              <p class="bank">{{conta.pix}}</p>
            </ion-col>
            <ion-col size="1" (click)="copiar(conta.pix)">
              <i class="fa-thin fa-copy"></i>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-item>
    </ion-accordion>
  </ion-accordion-group>
  <sem-registro *ngIf="contas.length == 0"></sem-registro>
</ion-content>
